import React from "react";
import { useTranslation } from "react-i18next";

const ContactCard = ({ icon, alt, label, value, value1, value2 }) => {
    const { i18n } = useTranslation();
    const isRtl = i18n.dir() === "rtl";
    const dirStyle = { direction: isRtl ? "rtl" : "ltr" };

    return (
        <div className="col-8">
            <div className="needPadding pt-3 d-flex flex-row" id="needBorder borderTitle">
                <div>
                    <img src={icon} alt={alt} className="min-w-10" />
                </div>
                <div className={isRtl ? "pr-3" : "pl-3"}>
                    <p className="supportCard-para fs-14 fw-400 m-0">{label}</p>

                    {value && (
                        <p className="supportCard-para-highlight fs-16 fw-800" style={dirStyle}>
                            {value}
                        </p>
                    )}

                    {value1 && value2 && (
                        <>
                            <p className="supportCard-para-highlight fs-16 fw-800 flex items-center gap-2" style={dirStyle}>
                                <span className="text-md" style={dirStyle}>•</span>
                                {value1}
                            </p>
                            <p className="supportCard-para-highlight fs-16 fw-800 flex items-center gap-2" style={dirStyle}>
                                <span className="text-md" style={dirStyle}>•</span>
                                {value2}
                            </p>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ContactCard;